/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero Org API
 * The Impero Backend's API for organizations, i.e. orgname.impero.com.
 */

export type Friction = (typeof Friction)[keyof typeof Friction];

export const Friction = {
    NoFriction: "NoFriction",
    Friction: "Friction",
    HighFriction: "HighFriction",
} as const;
